<template>
  <div class="login col-sm-10 col-md-8 rounded-borders">
    <h4 class="title q-mt-none text-h4 text-center">
      {{ $t(`button.${isLogin ? 'log_in' : 'sign_up'}`) }}
    </h4>
    <q-banner
      v-if="invitation && !invitation.error && !account"
      class="invitation q-mb-lg"
      rounded
    >
      <div
        v-html="$t('invitation.join_gettransfer', {
          email: invitation.inviter_email,
        })"
      />
      <template #action>
        <q-btn
          color="red"
          :label="$t('button.reject_invitation')"
          outline
          @click="rejectInvitation"
        />
      </template>
    </q-banner>
    <template v-if="!hideSocialLogin">
      <social-auth
        class="social row justify-center no-wrap-sm"
        @success="onSocialAuth"
      />
      <div class="text-center text-grey-7 q-my-lg">
        {{ $t('label.or') }}
      </div>
    </template>
    <slot />

    <div
      v-if="account"
      class="text-center q-mt-md"
    >
      <div>
        {{ $t('notice.account_exists.log_in') }}
      </div>
      <div>
        {{ $t('notice.account_exists.requests_moved') }}
      </div>
    </div>
    <div
      v-else
      class="text-center fs-14 q-mt-md"
    >
      <span>{{ $t(`label.${isLogin ? 'not_' : ''}have_account`) }}</span>
      <router-link
        :to="{
          name: `account.${isLogin ? 'new' : 'login' }`,
        }"
      >
        {{ $t(`button.${isLogin ? 'sign_up' : 'log_in'}`) }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SocialAuth from '~components/SocialAuth';

import Dialog from '~mixins/Dialog';

export default {
  name: 'AuthForm',
  components: {
    SocialAuth,
  },
  mixins: [
    Dialog,
  ],
  props: {
    hideSocialLogin: {
      type: Boolean,
      default: false,
    },
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['account', 'invitation']),
  },
  mounted() {
    if (this.invitation?.error) {
      this.showDialog({
        message: this.$t('invitation.outdated'),
      });

      this.$store.dispatch('invitations/removeInvitation');
    }
  },
  methods: {
    onSocialAuth({ redirect_url }) {
      if (redirect_url) {
        window.location.href = redirect_url;
      }
    },
    rejectInvitation() {
      this.showDialog({
        message: this.$t('confirm.reject_invitation'),
        ok: {
          color: 'red',
          label: this.$t('button.reject'),
        },
        persistent: true,
      })
        .onOk(() => {
          this.$axios.put(`/api/invitations/reject/${this.invitation.uuid}`);

          this.$store.dispatch('invitations/removeInvitation');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.invitation {
  border: 1px solid $grey-6;
}

.login {
  box-shadow: 0 0 10px 0 #eaeaea;
  max-width: 700px;
  padding: 60px 6vw;
}

.social ::v-deep .q-btn__content {
  flex-wrap: nowrap !important;
}

.title {
  font-size: 26px;
  margin-bottom: 60px;
}
</style>
